<script src="../../../../Games/2020/Pincremental/Code/js/obBall.js"></script>
<template>
  <div class="page-demo">
    <!--banner-->
    <div class="banner">
      <div class="container">
        <h2 class="timeline">所有游戏</h2>
      </div>
    </div>
    <!--banner-->

    <!--游戏分类 start-->
    <div class="container" style="padding:2em 0;">
      <div class="games tj">
      </div>
      <div class="sap_tabs">

        <div id="horizontalTab" style="display: block; width: 100%; margin: 0px;">
          <ul class="resp-tabs-list">
            <li class="text">语言：</li>
            <li class="resp-tab-item" @click="getItem(36)"><span>推荐</span></li>
            <li class="resp-tab-item" @click="getItem(40)"><span>最近更新</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">语言：</li>
            <li class="resp-tab-item" @click="getItem(1)"><span>已汉化</span></li>
            <li class="resp-tab-item" @click="getItem(2)"><span>汉化中</span></li>
            <li class="resp-tab-item" @click="getItem(14)"><span>英文</span></li>
            <li class="resp-tab-item" @click="getItem(15)"><span>日文</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">平台：</li>
            <li class="resp-tab-item" @click="getItem(13)"><span>K站</span></li>
            <li class="resp-tab-item" @click="getItem(18)"><span>PC</span></li>
            <li class="resp-tab-item" @click="getItem(19)"><span>Steam</span></li>
            <li class="resp-tab-item" @click="getItem(16)"><span>安卓</span></li>
            <li class="resp-tab-item" @click="getItem(17)"><span>苹果</span></li>
            <li class="resp-tab-item" @click="getItem(34)"><span>微信</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">类型：</li>
            <li
                v-for="(t,index) in typeList"
                class="resp-tab-item"
                @click="getItem(index)"
                v-if="index != 0 && index != 1 && index != 2 && index != 14 && index != 13 && index != 16 && index != 17 && index != 18 && index != 19 && index != 34 && index != 36 && index != 15 && index != 40">
              <span>{{ t }}</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">筛选：</li>
            <li v-for="(t,index) in sortTypeList" class="resp-tab-item no-color" :key="index"><span>{{ t }}</span><em
                @click="delItem(t)">X</em></li>
            <li class="resp-tab-item reset" @click="clearSortItem()"><span>清空</span></li>
            <div class="clearfix"></div>
          </ul>
          <div class="resp-tabs-container">
            <div
                v-for="(t,index) in typeList"
                class="tab-1 resp-tab-content"
                :aria-labelledby="'tab_item-'+index"
                v-if="activeClass==index">
              <section>
                <ul id="da-thumbs" class="da-thumbs">
                  <li v-for="game in gameData" v-if="game.status === 1">
                    <!--非Flash-->
                    <em class="b-link-stripe b-animate-go  thickbox" v-if="!game.flash">
                      <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                        <div class="face-box games" :title="game.title">
                          <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                            <div slot="placeholder" class="img-placeholder small">
                              图片加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </router-link>
                      <div>
                        <h5>
                          {{ game.title }}
                          <span v-if="game.version">v {{ game.version }}</span>
                          <span v-if="!game.version"> </span>
                        </h5>
                        <p>
                          <router-link
                              class="hvr-wobble-top"
                              :to="'/game/'+game.path"
                              :title="game.title"
                              target="_blank">
                            看介绍
                          </router-link>
                          <a
                              class=" hvr-wobble-top"
                              v-if="game.zhUrl || game.enUrl"
                              :href="game.zhUrl?game.zhUrl:game.enUrl"
                              target="_blank">玩游戏</a>
                          <a
                              class=" hvr-wobble-top"
                              v-if="!game.zhUrl && !game.enUrl && game.customUrl"
                              :href="game.customUrl"
                              target="_blank">玩游戏</a>
                        </p>
                      </div>
                    </em>
                    <!--Flash-->
                    <em class="b-link-stripe b-animate-go  thickbox" v-if="game.flash">
                      <a :href="'static/flash/'+game.path+'.html'" :title="game.title" target="_blank">
                        <div class="face-box games" :title="game.title">
                          <el-image class="img-responsive" :src="'static/images/game/'+game.path+'/jietu-1.png'" :alt="game.title">
                            <div slot="placeholder" class="img-placeholder small">
                              图片加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </a>
                      <div>
                        <h5>
                          {{ game.title }}
                          <span v-if="game.version">v {{ game.version }}</span>
                          <span v-if="!game.version"> </span>
                        </h5>
                        <p>
                          <a
                              class=" hvr-wobble-top"
                              :href="'static/flash/'+game.path+'.html'"
                              :title="game.title"
                              target="_blank">
                            看介绍
                          </a>
                          <a
                              class=" hvr-wobble-top"
                              :href="'static/flash/'+game.path+'.html'"
                              :title="game.title"
                              target="_blank">
                            玩游戏
                          </a>
                        </p>
                      </div>
                    </em>
                  </li>

                  <div class="clearfix"></div>
                </ul>
              </section>
            </div>
          </div>
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[12, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--游戏分类 end-->
  </div>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  data() {
    return {
      total: 0,
      currentPage: 1, // 默认显示第1页
      pagesize: 12, // 默认一次显示12条数据
      typeList: [],
      sortTypeList: [],
      gameList: [],
      curType: '全部游戏',
      activeClass: 0
    }
  },
  created() {
    this.getType()
    this.getData(0)
    // SyntaxHighlighter.all();
  },
  mounted() {
  },
  beforeDestroy() {
    this.typeList = []
    this.sortTypeList = []
    this.gameList = []
  },
  computed: {
    gameData: function () {
      return this.gameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    }
  },
  methods: {
    getType() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/type.json' + '?' + timeStamp).then(res => {
            this.typeList = res.data[0]
            this.curType = this.typeList[this.activeClass]
          },
          res => {
            console.log('error')
          }
      )
    },
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        console.log('请求数据时，类型', this.curType)
        if (this.curType === '全部游戏') {
          for (var i = 0; i < game.data.length; i++) {
            if (game.data[i].status === 1) {
              this.gameList.push(game.data[i])
            }
          }
        } else if (this.curType === '最近更新' && this.sortTypeList.length === 1) {
          // 最近更新
          var rows = game.data
          // 转换日期格式为时间戳
          for (var r = 0, l = rows.length; r < l; r++) {
            var a = rows[r].update
            if (a) {
              var date1 = Date.parse(new Date(a))
              rows[r].update = date1
              this.gameList.push(rows[r])
            }
          }
          // 排序
          this.gameList.sort(this.compare('update'))
          // 排序完，还原日期格式
          this.gameList.forEach(el => {
            const date = new Date(el.update)
            const year = date.getFullYear()
            const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
            const day = date.getDate() + 1 > 9 ? date.getDate() + 1 : '0' + (date.getDate() + 1)
            el.update = year + '-' + month + '-' + day
          })
          this.gameList.reverse()
        } else {
          for (var i = 0; i < game.data.length; i++) {
            this.gameList = game.data.filter(function (data_element, data_index, data) {
              return game.data[i].status === 1 && this.sortTypeList.every(function (sortType_element, sortType_index, sortTypeList) {
                return data_element.type.includes(sortType_element)
              })
            }, this)
          }
        }

        this.total = this.gameList.length

        if (this.gameList.length < 1) {
          this.$notify({
            title: '提示',
            message: '没找到你要查找的游戏，您可以减少筛选条件试试~',
            type: 'warning',
            duration: 1500
          })
        }
      })
    },
    getItem(index) {
      // 筛选条件
      this.activeClass = index
      this.gameList = []
      // 获取点击的分类
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/type.json' + '?' + timeStamp).then(res => {
        this.curType = this.typeList[index]
        if (index === 0) {

        } else {
          // 如果筛选条件为空，则添加第一个条件
          if (this.sortTypeList.length === 0) {
            this.sortTypeList.push(this.typeList[index])
          } else {
            // 判断筛选条件是否重复
            if (this.sortTypeList.indexOf(this.curType) < 0) {
              this.sortTypeList.push(this.typeList[index])
            }
          }
          console.log('筛选类型集合:', this.sortTypeList)
        }
      })
      if (this.sortTypeList.length === 0) {
        this.curType = '全部游戏'
      }
      this.getData()
      // 显示第一页数据
      this.currentPage = 1
    },
    delItem(text) {
      // 删除筛选条件
      for (var i = 0; i < this.sortTypeList.length; i++) {
        if (this.sortTypeList[i] === text) {
          this.sortTypeList.splice(i, 1)
        }
      }
      if (this.sortTypeList.length > 0) {
        this.curType = this.sortTypeList[this.sortTypeList.length - 1]
      }
      console.log('删除后筛选数组剩余条件:', this.sortTypeList)
      this.gameList = []
      this.getData()
      // 显示第一页数据
      this.currentPage = 1
    },
    clearSortItem() {
      // 重置筛选条件
      if (this.sortTypeList.length != 0) {
        this.sortTypeList = []
        this.gameList = []
        this.curType = '全部游戏'
        this.getData()
        // 显示第一页数据
        this.currentPage = 1
      } else {
        this.$notify({
          title: '提示',
          message: '请选择一个筛选条件',
          type: 'warning',
          duration: 1500
        })
      }
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    },
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop]
        var val2 = obj2[prop]
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Games.vue